import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateService } from '@services/template.service';
import { RequirementService } from 'src/app/services/requirement.service';

@Component({
    selector: 'app-delete-template',
    templateUrl: './delete-template.component.html',
    styleUrls: ['./delete-template.component.scss'],
    standalone: false
})
export class DeleteTemplateComponent implements OnInit {

	@Output() deleteFile = new EventEmitter<boolean>();
	@Input () idFile: number;
	@Input () title: string;
	@Input () message: number = -1;
  @Input () body;

	loading: boolean = false;
  constructor(
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
    private _templateService: TemplateService
	) { }

  ngOnInit() {
  }
	confirmDelete(event) {
		if (event) {
      this.loading=true;

      this._templateService.Delete(this.body).subscribe((resp) => {
          if (resp['error']) {
            this.loading=false;
            this.message = 0;
          } else {
            this.message = 1;
            this.loading = false;
            setTimeout(() => this.activeModal.dismiss(), 1500);
            setTimeout(() => this.deleteFile.emit(true), 1500);
          }
        });
		}
	}
}
